'use client';

import React, {useEffect} from "react";
import Button from "../../UiElements/Button"
import * as THREE from "three";


import Form, {FormGeneratorHandles} from "@/components/Form";
import lightingFormItems from "../forms/lightingFormItems"
import { environmentUrl, resolveEnvironmentMap } from '@/shared/productViewer'
import initEnvironment from '@/components/ProductProfile/utils/initEnvironment'

interface LightingFormProps {
    lights?:any
    isOpen?: boolean,
    close?: () => void,
    onUpdate?: (lights:Record<string, any>) => void
}

interface LightingFormState {
    toneMappingExposure: number,
    keyLightIntensity: number,
    fillLightIntensity: number,
    engravingTintIntensity: number,
}

const LightingForm: React.FC<LightingFormProps> = ({ lights = {}, isOpen, close, onUpdate }) => {


    const formRef = React.useRef<FormGeneratorHandles>(null);


    const handleChangeLights = (formData: any) => {
		if (isOpen) {

			onUpdate?.(formData)
			updateRender(formData)
		}
    }

    const updateRender = (lightFormData: LightingFormState) => {
        const threeViewer = (window as any).threeViewer;
        if (threeViewer) {

            // The environment map. Loaded through initEnvironment, which caches, so flicking
            // between options costs one fetch each and nothing after that.
            const wanted = resolveEnvironmentMap(lightFormData)
            if (threeViewer.__environmentMap !== wanted) {
                threeViewer.__environmentMap = wanted
                initEnvironment(threeViewer, environmentUrl(wanted))
            }

            threeViewer.renderer.toneMappingExposure = Number(lightFormData.toneMappingExposure)
            threeViewer.fillLight.intensity = Number(lightFormData.fillLightIntensity)
            threeViewer.keyLight.intensity = Number(lightFormData.keyLightIntensity)

            const newTint = new THREE.Color().setHSL(0, 0, lightFormData.engravingTintIntensity || 0)
            threeViewer.overlyTint = newTint

            // Update the overlayTint uniform on all meshes that have it
            if (threeViewer.product) {
                threeViewer.product.traverse((child: any) => {
                    if (child.isMesh && child.material?.userData?.shader?.uniforms?.overlayTint) {
                        child.material.userData.shader.uniforms.overlayTint.value = newTint
                    }
                })
            }
        }
    }



    useEffect(() => {


        if (lights.engravingTintIntensity) {
			console.log('lighting form use effect', lights)
            formRef.current?.setData(lights)
            updateRender(lights)
        }
        updateRender(lights)
    }, [lights]);



    return(
        <div
            className={`bg-white rounded-md  ${isOpen? ' !w-[350px] !h-auto' : '!w-[0px] !h-0'}  flex flex-col gap-md  overflow-y-auto relative transition-all`}>
            <div className={'p-md'}>
                <div className={' flex flex-row justify-center item-center h-[27px] '}>
                    <div
                        className={'flex flex-grow item-center text-title-lg capitalize'}>Lights</div>

                    <Button
                        onClick={close}
                        className={
                            'font-icon-solid !w-[37px] !h-[37px] overflow-hidden !items-center !justify-center flex text-[18px] !p-0 relative top-[-5px] right-[-10px]'
                        }
                        type={'link'}
                    >
                        
                    </Button>
                </div>
            </div>

            <div
                className={`transition-all  relative duration-500 max-h-calc(100vh-350px)`}
            >
                <div
                    className="flex items-start gap-[30px]  flex-row transition-all duration-500 "

                >

                        <div className={'w-[350px] px-md'}>
                            <div className={'grid grid-cols-1 gap-md !w-[100%] pb-[20px] '}>
                                <Form
                                    ref={formRef}
                                    items={lightingFormItems}
                                    defaultValues={lights}
                                    onChange={handleChangeLights}
                                />
                            </div>
                        </div>


                </div>
            </div>
        </div>
    )
}

export default LightingForm